import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: process.env.NEXT_PUBLIC_THEME_PRIMARY_COLOR || '#47E1BC',
    },
    secondary: {
      main: '#fff',
    },
    text: {
      primary: '#fff',
    },
    divider: '#F4F6FF',
    error: {
      main: '#d0342c',
    },
    success: {
      main: '#4ECB71',
    },
  },
  typography: {
    allVariants: {
      fontFamily: 'Manrope !important',
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          borderRadius: 20,
        },
        sizeLarge: {
          fontSize: '1rem', // Example of a font size override for large buttons
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#2D3C4A',
          boxShadow: 'none',
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: '0.75rem',
          color: 'rgba(255, 255, 255, 0.5)',
          '&.Mui-active': {
            color: '#fff',
            fontWeight: 600,
          },
          '&.Mui-completed': {
            color: 'rgba(255, 255, 255, 0.8)',
          },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: 'rgba(255, 255, 255, 0.3)',
          '&.Mui-active': {
            color: theme.palette.primary.main,
          },
          '&.Mui-completed': {
            color: theme.palette.primary.main,
          },
        }),
        text: {
          fill: '#0B1620',
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: 'rgba(255, 255, 255, 0.15)',
        },
      },
    },
  },
});
